export type Term = {
  id: string;
  organizationId: string;
  organizationName: string;
  ordinal: number;
  displayName: string;
  startOn: string | null;
  endOn: string | null;
  isCurrent: boolean;
  closedAt: string | null;
  closedReason: string | null;
  sourceRef: string;
  placeholderRef: string | null;
  version: number;
  liveAppointmentCount: number;
};

export type Appointment = {
  id: string;
  organizationId: string;
  organizationName: string;
  sourceRef: string;
  termId: string;
  termDisplayName: string;
  personId: string;
  displayName: string;
  postCode: string;
  postLabel: string;
  startOn: string | null;
  endOn: string | null;
  endedReason: string | null;
  version: number;
  isCurrent: boolean;
};

export type OrgNode = {
  id: string;
  name: string;
  shortName: string | null;
  divisionCode: string | null;
  divisionLabel: string | null;
  parentId: string | null;
  kind: {
    code: string;
    displayName: string;
    canHoldMembership: boolean;
    canHaveChildren: boolean;
  } | null;
  lifecycle: "ACTIVE" | "ARCHIVED";
  version: number;
  memberCount: number;
  childCount: number;
  children: OrgNode[];
};

export type OrgKind = {
  code: string;
  displayName: string;
  canHoldMembership: boolean;
  canHaveChildren: boolean;
  canApprove: boolean;
};

export type MoveImpact = {
  impactDigest: string;
  grants: Array<{
    accountLabel: string;
    roleCode: string;
    effect: "GAINS" | "LOSES";
    organizationCount: number;
  }>;
};

export function flatten(nodes: OrgNode[], depth = 0): Array<{ node: OrgNode; depth: number }> {
  return nodes.flatMap((node) => [{ node, depth }, ...flatten(node.children, depth + 1)]);
}
